import React from "react";
import { motion } from "framer-motion";
import Container from "react-bootstrap/Container";
import IndustriesCards from "../Components/IndustriesCards";
import Button from "../Components/Button";
import SEO from "../Components/SEO";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const industriesSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Industries We Serve - ElectroPlating Lebanon",
  "description": "ElectroPlating Lebanon provides specialized metal finishing solutions for automotive, jewelry, furniture, plumbing, restoration, and military industries.",
  "url": "https://www.electroplating-lb.com/industries",
  "mainEntity": {
    "@type": "ItemList",
    "name": "Industries Served",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Automotive" },
      { "@type": "ListItem", "position": 2, "name": "Jewelry" },
      { "@type": "ListItem", "position": 3, "name": "Furniture" },
      { "@type": "ListItem", "position": 4, "name": "Plumbing" },
      { "@type": "ListItem", "position": 5, "name": "Restoration" },
      { "@type": "ListItem", "position": 6, "name": "Military" }
    ]
  }
};

const IndustriesPage = () => {
  return (
    <main>
      <SEO
        title="Industries We Serve"
        description="ElectroPlating Lebanon serves diverse industries including automotive, jewelry, furniture, plumbing, restoration, and military sectors with specialized metal finishing solutions."
        keywords="automotive electroplating, jewelry plating, furniture metal finishing, plumbing fixtures plating, antique restoration, military equipment plating, industrial electroplating"
        canonicalUrl="/industries"
        structuredData={industriesSchema}
      />

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
        variants={fadeInUp}
      >
        <IndustriesCards />
      </motion.div>

      {/* CTA Section */}
      <motion.section
        className="industries-cta-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeInUp}
      >
        <Container>
          <div className="industries-cta-content">
            <h2 className="industries-cta-title">Don't See Your Industry?</h2>
            <p className="industries-cta-text">
              We work with businesses across many sectors. Contact us to discuss
              how our electroplating services can benefit your specific industry.
            </p>
            <Button to="/contact" variant="primary" size="lg">
              Contact Us <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
            </Button>
          </div>
        </Container>
      </motion.section>
    </main>
  );
};

export default IndustriesPage;
